<div class="cancel-dialog-container">
  <div class="cancel-dialog-content">
    <div class="cancel-icon-wrapper">
      <div class="cancel-icon">😢</div>
    </div>
    
    <h2 class="cancel-title">¿Nos dejas?</h2>
    <p class="cancel-subtitle">Lamentamos verte partir. Tu cuenta se cancelará al final del período de facturación actual.</p>

    <div class="cancel-info-card">
      <div class="info-icon">ℹ️</div>
      <div class="info-content">
        <strong>¿Cambias de opinión?</strong>
        <p>Podrás reactivar tu suscripción en cualquier momento antes de que finalice el período actual.</p>
      </div>
    </div>

    <div class="cancel-benefits">
      <h3 class="benefits-title">Lo que conservarás:</h3>
      <div class="benefit-list">
        <div class="benefit-item">
          <div class="benefit-icon">✓</div>
          <span>Acceso completo hasta el fin de tu período</span>
        </div>
        <div class="benefit-item">
          <div class="benefit-icon">✓</div>
          <span>Todo tu historial de facturas y contactos</span>
        </div>
        <div class="benefit-item">
          <div class="benefit-icon">✓</div>
          <span>Configuración guardada</span>
        </div>
        <div class="benefit-item">
          <div class="benefit-icon">✓</div>
          <span>Reactivación sin problemas cuando quieras volver</span>
        </div>
      </div>
    </div>

    <div class="cancel-actions">
      <button type="button" class="btn btn-stay" (click)="onStay()">
        <span class="btn-icon">🎉</span>
        ¡Me quedo con Handly!
      </button>
      <button type="button" class="btn btn-cancel" (click)="onContinueCancel()">
        Continuar con la cancelación
      </button>
    </div>

    <p class="cancel-footer">
      ¿Necesitas ayuda? <a href="mailto:soporte@handly.es" class="support-link">Contacta con soporte</a>
    </p>
  </div>
</div>
